/**
 * General tab view used for name, description, address, contact, coordinates etc.
 */
export const TAB_GENERAL = 'TAB_GENERAL';
/**
 * Thumbnail tab view used for editing the location thumbnail.
 */
export const TAB_THUMBNAIL = 'TAB_THUMBNAIL';
/**
 * Unit tab view used for unit summary and available units.
 */
export const TAB_UNIT = 'TAB_UNIT';
/**
 * Payment tab view used for payment processing information.
 */
export const TAB_PAYMENT = 'TAB_PAYMENT';
/**
 * Media tab view used for image uploading.
 */
export const TAB_MEDIA = 'TAB_MEDIA';
/**
 * Media tab view used for image uploading.
 */
export const TAB_VIDEO = 'TAB_VIDEO';
